// @ts-ignore
/* eslint-disable */
import request from '../../utils/request';

/** 调研活动前端内容详情 GET /research-activity/front-content/detail */
export async function researchActivityFrontContentDetailUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.researchActivityFrontContentDetailUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultResearchActivityFrontContentInfoResp>(
    '/research-activity/front-content/detail',
    {
      method: 'GET',
      params: {
        ...params,
      },
      ...(options || {}),
    },
  );
}

/** 调研活动前端内容列表 GET /research-activity/front-content/list */
export async function researchActivityFrontContentListUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.researchActivityFrontContentListUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.PageResultListResearchActivityFrontContentInfoResp>(
    '/research-activity/front-content/list',
    {
      method: 'GET',
      params: {
        ...params,
      },
      ...(options || {}),
    },
  );
}

/** 调研活动前端内容发布列表（近一年最大涨幅前三） GET /research-activity/front-content/top-list */
export async function researchActivityFrontContentTopListUsingGET(options?: {
  [key: string]: any;
}) {
  return request<API.BaseResultListResearchActivityFrontContentInfoResp>(
    '/research-activity/front-content/top-list',
    {
      method: 'GET',
      ...(options || {}),
    },
  );
}
